import React from "react";
import { Card, CardContent, Typography, Box, Grid, Avatar } from "@mui/material";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import CategoryIcon from "@mui/icons-material/Category";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ExerciseDetails = ({ exercise }) => {
  if (!exercise) return null;

  return (
    <Card sx={{ maxWidth: 800, margin: "auto", padding: 2, boxShadow: 3 }}>
      {/* Exercise GIF */}
      <Box display="flex" justifyContent="center" mb={2}>
        <Avatar
          variant="rounded"
          src={exercise.gif_url || ""}
          alt={exercise.exercise_name || "Exercise GIF"}
          sx={{ width: "100%", height: "auto", objectFit: "contain" }}
        />
      </Box>

      <CardContent>
        {/* Exercise Name */}
        <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom>
          {exercise.exercise_name || "Not Available"}
        </Typography>

        {/* Details Grid */}
       

        {/* Instructions */}
        <Box >
          <Typography variant="h6" fontWeight="bold">
            Instructions
          </Typography>
          <ul>
            {exercise.instructions
              ? JSON.parse(exercise.instructions).map((step, index) => (
                  <li key={index} style={{textAlign:"left"}}>
                    <Typography variant="body1">{step}</Typography>
                  </li>
                ))
              : "Not Available"}
          </ul>
        </Box>

        {/* Proper Form & Breathing */}
        <Box mt={3}>
          <Typography variant="h6" fontWeight="bold">
            Proper Form & Breathing
          </Typography>
          <Typography variant="body1" style={{textAlign:"left"}}>{exercise.proper_form_breathing || "Not Available"}</Typography>
        </Box>

        {/* Exercise Benefits */}
        <Box mt={3}>
          <Typography variant="h6" fontWeight="bold">
            Benefits
          </Typography>
          <Typography variant="body1" style={{textAlign:"left"}}>{exercise.exercise_benefits || "Not Available"}</Typography>
        </Box>
        <Grid container spacing={2} mt={3}>
          <Grid item xs={12} sm={6} display="flex" alignItems="center">
            <FitnessCenterIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="body1">
              <strong>Primary Muscles:</strong> {exercise.primary_muscles?.replace(/"/g, "") || "Not Available"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} display="flex" alignItems="center">
            <DirectionsRunIcon color="secondary"/>
            <Typography variant="body1">
              <strong>Secondary Muscles:</strong> {exercise.secondary_muscles?.replace(/"/g, "") || "Not Available"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} display="flex" alignItems="center">
            <CategoryIcon color="success" sx={{ mr: 1 }} />
            <Typography variant="body1">
              <strong>Equipment:</strong> {exercise.equipment?.replace(/"/g, "") || "Not Available"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} display="flex" alignItems="center">
            <FormatListBulletedIcon color="error" sx={{ mr: 1 }} />
            <Typography variant="body1">
              <strong>Sets & Reps:</strong>{" "}
              {exercise.sets && exercise.units
                ? `${JSON.parse(exercise.sets)[0] || "Not Available"} ${JSON.parse(exercise.units)[0] || ""}, ${JSON.parse(exercise.sets)[1] || "Not Available"} ${JSON.parse(exercise.units)[1] || ""}`
                : "Not Available"}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ExerciseDetails;
